import React, { useEffect, useState } from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";
import "./style.css";
import { useRoles } from "./roles";
import { makeStyles } from "@material-ui/styles";
import MaterialIcon from "../../materialIcon/materialIcon";
import useStyles from "./style";
import { Grid, Avatar, Paper, Button, IconButton } from "@material-ui/core";
import { getById } from "../../../actions/user-config-actions";
import Checkbox from "@material-ui/core/Checkbox";

export default function Drag({ setFavorites, setHasDragChanges }) {
  var { rolMenu, userId } = useRoles();
  const [itemsPrev, setItemsPrev] = useState(null);
  useEffect(() => {
    const getFavoritesAsync = async () => {
      let response = await getById(userId);
      var favorites = response.data.shortcutResponseList;
      if (favorites) {
        let orderFavorite = rolMenu.map((rol) => {
          let favorite = favorites.find((x) => x.moduleId === rol.roleId);
          if (favorite) {
            rol.newOrder = favorite.order;
          }

          return rol;
        });
        orderFavorite.sort((a, b) => a.newOrder - b.newOrder);
        setItemsPrev(orderFavorite);
      } else {

        setItemsPrev(rolMenu);
      }
    };
    getFavoritesAsync();
  }, []);

  const classes = useStyles();
  const onSortEnd = (oldIndex, newIndex) => {
    setHasDragChanges(true);

    let changeOrder = arrayMove(itemsPrev, oldIndex, newIndex);

    setItemsPrev((array) => arrayMove(array, oldIndex, newIndex));
    setTimeout(() => {
      let orderFavorite = changeOrder.map((rol, index) => {
        rol.order = index + 1;
        rol.newOrder = index + 1;
        return rol;
      });

      setFavorites(orderFavorite);
    }, 100);
  };

  return (
    <SortableList
      onSortEnd={onSortEnd}
      className="list"
      draggedItemClassName="dragged"
    >
      {itemsPrev?.map((menu) => (
        <SortableItem key={menu.newOrder}>
          <Grid item  md={3} >
          <Checkbox
                  color="primary"
                  name={`checkBox${menu.id}`}
                  inputProps={{ "aria-label": "secondary checkbox" }}
                  style={{top:"26px",padding:"1px"}}
                  // checked={modelo.isChecked}
                  // onChange={(event) => onChangeClause(event, modelo.id)}
                />
            <Paper elevation={2} className={classes.containerAtajos}>

              <IconButton className={classes.icon}>
                <MaterialIcon fill="outlined" name={menu?.icon} />
              </IconButton>
              <h1 className={classes.titleAcces}>{menu?.title}</h1>
            </Paper>
          </Grid>
        </SortableItem>
      ))}
    </SortableList>
  );
}
